export const PLATFORM_CONTANTS = 'platform/constants/list';
export const AIRCRAFT_TYPES = 'platform/aircraft_types';
export const PORTFOLIO_LIST = 'platform/portfolios';
export const ENGINE_TYPES = 'platform/engine_types';
export const LESSOR_LIST = 'platform/lessor';
export const REGION_LIST = 'platform/regions';
export const LESSEE_LIST = 'platform/lessee';
export const OPERATOR_LIST = 'platform/operator';
export const MANUFACTURER_LIST = 'platform/manufacturer';
export const APU_TYPES = 'platform/apu_types';
export const APPS_SWITCHER = 'platform/app/switcher';
export const SHOW_FORCE_CHANGE_PASSWORD_MODAL = 'SHOW_FORCE_CHANGE_PASSWORD_MODAL';
export const HIDE_FORCE_CHANGE_PASSWORD_MODAL = 'HIDE_FORCE_CHANGE_PASSWORD_MODAL';
export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';
export const CLEAR_TOAST = 'CLEAR_TOAST';